import { GetSourceDataById, SourceDataSingleResponse } from '@/api/dtos';
import { useGet, usePost } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { ISourceDataConfiguration } from '../../api/dtos';

const getData = (response?: SWRResponse<SourceDataSingleResponse, SourceDataSingleResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<SourceDataSingleResponse, SourceDataSingleResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useSourceDataById = (id?: number, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return id ? 
            () => new GetSourceDataById({ id }) : 
            undefined;
    }, [id]);

    return useGet(request, { getData, getError}, configuration);
};

export default useSourceDataById;